import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAppNavigate } from '~/pages';
import {
    fakeItemsArray,
    I18nReacher,
    useSpringBigStore,
    useTheme,
    useTransactionDetails,
} from '@springbig/shared';
import { Section } from '~/shared/Theme';
import { VStack, ChevronLeftIcon, HStack, Skeleton } from 'native-base';
import { Caption } from '~/shared/Typography';
import OurPressable from '~/shared/Pressable';
import TransactionHeader from './TransactionHeader';
import { format } from 'date-fns';
import { Panel } from '~/shared/Theme';

const TransactionDetails = () => {

    const { member, merchant } = useSpringBigStore();
    const { params } = useAppNavigate();
    const { state: { transaction, cardNumber } } = useLocation();

    const { primary } = useTheme();

    const {
        isLoading,
        transactionRecords
    } = useTransactionDetails(params, transaction);

    const dollarPerPoint = parseFloat(merchant?.dollars_per_point || '0.0');

    const detailsComponentText = (key : string, value: string) => {

        if (key === 'pointsRedeemed') {
            if (transactionRecords.provider === 'points_for_cash') {
                return ((transaction.load_amount_cents / 100) * dollarPerPoint).toFixed(0);
            }

            return '-';
        }

        if (key === 'giftCardDigits') {
            return cardNumber?.substring(cardNumber.length - 4);
        }

        if (key === 'date') {
            return format(new Date(transaction.created_at), 'MM-dd-yyyy HH:mm:ss');
        }

        return value;
    };

    return (
        <Section>
            <TransactionHeader />
            <HStack p={4} justifyContent={'space-between'} alignItems={'baseline'}>
                <OurPressable onPress={() => window.history.back()}>
                    <ChevronLeftIcon size={'lg'} color={primary} />
                </OurPressable>
                { isLoading ?
                    <Skeleton.Text lines={1} width={70} />
                    :
                    <Caption text='giftCard.transactions.details.id' textValues={[transaction.id]} />
                }
            </HStack>
            <VStack>
                <VStack space={2} p={4}>
                    <HStack>
                        <Caption
                            w={'70%'}
                            text='giftCard.transactions.details.card_holder_name'
                        />
                        <Caption w={'30%'} textAlign={'left'}>
                            {member?.first_name} {member?.last_name}
                        </Caption>
                    </HStack>
                    <HStack>
                        <Caption w={'70%'} text='giftCard.transactions.details.customer_authorization' />
                        <Caption w={'30%'} textAlign={'left'} text='giftCard.transactions.details.confirmed' />
                    </HStack>
                </VStack>
                { isLoading ?
                    fakeItemsArray.map((_, index) =>

                        <TransactionDetailsSkeleton key={index} />
                    )
                    :
                    Object.entries(transactionRecords).map(([key, value]) => {

                        return (
                            <Panel key={key} row>
                                <Caption w={'70%'} text={`giftCard.transactions.details.${key}` as I18nReacher} />
                                <Caption w={'30%'} textAlign={'start'}>
                                    { detailsComponentText(key, value) }
                                </Caption>
                            </Panel>
                        );
                    })
                }
            </VStack>
        </Section>
    );
};

const TransactionDetailsSkeleton = () => {

    return (
        <Panel row justifyContent={'space-between'} py={5}>
            <Skeleton.Text lines={1} width={130} />
            <Skeleton.Text lines={1} width={70} />
        </Panel>
    );
};

export default TransactionDetails;
